// extracted by mini-css-extract-plugin
export default {"VideoFeedback":"_VideoFeedback--Z9IrI","CameraOffIcon":"_CameraOffIcon--wZoBJ"};